module.exports={key:"byld.symbo.ls",framework:"domql",npmClient:"yarn",useWorkspaces:!0};